// const TEST_HOST = 'https://test-apaas.grtcloud.net/',
const TEST_HOST = 'https://test-apaas.grtcloud.net/',
    PROD_HOST = 'https://apaas.grtcloud.net/',
    ENV_CONFIG = {
        test: {
            tmeAvatarUrl: '',
            API_BASE_HOST: TEST_HOST,
            API_BASE_URI: 'dpaas-chat-bi/',
            API_BASE_URL: `${TEST_HOST}/dpaas-chat-bi/api/semantic/`,
            CHAT_API_BASE_URL: `${TEST_HOST}/dpaas-chat-bi/api/chat/`,
            AUTH_API_BASE_URL: `${TEST_HOST}/dpaas-chat-bi/api/auth/`
        },
        development: {
            tmeAvatarUrl: '',
            API_BASE_HOST: TEST_HOST,
            API_BASE_URI: 'dpaas-chat-bi/',
            API_BASE_URL: `${TEST_HOST}/dpaas-chat-bi/api/semantic/`,
            CHAT_API_BASE_URL: `${TEST_HOST}/dpaas-chat-bi/api/chat/`,
            AUTH_API_BASE_URL: `${TEST_HOST}/dpaas-chat-bi/api/auth/`
        },
        prod: {
            tmeAvatarUrl: '',
            API_BASE_HOST: PROD_HOST,
            API_BASE_URI: 'dpaas-chat-bi/',
            API_BASE_URL: `${PROD_HOST}/dpaas-chat-bi/api/semantic/`,
            CHAT_API_BASE_URL: `${PROD_HOST}/dpaas-chat-bi/api/chat/`,
            AUTH_API_BASE_URL: `${PROD_HOST}/dpaas-chat-bi/api/auth/`
        },
        production: {
            tmeAvatarUrl: '',
            API_BASE_HOST: TEST_HOST,
            API_BASE_URI: 'dpaas-chat-bi/',
            API_BASE_URL: `${TEST_HOST}/dpaas-chat-bi/api/semantic/`,
            CHAT_API_BASE_URL: `${TEST_HOST}/dpaas-chat-bi/api/chat/`,
            AUTH_API_BASE_URL: `${TEST_HOST}/dpaas-chat-bi/api/auth/`
        }
    }[process.env.REACT_APP_MODE || 'prod'];
export default ENV_CONFIG;
